import { FILTER_MAX_RESULT_VISIBLE } from 'constant'
import { slice, sortBy } from 'lodash'
import { useEffect, useMemo, useState } from 'react'

import { FilterType, OptionsType } from 'services/types'
import { MFilters } from 'types/filterTypes'

const useInitialOptions = (filter: FilterType, sortedOptions: OptionsType[], savedOptions: MFilters.FilterTypes[MFilters.FilterKey], isOpen?: boolean) => {
  const { type } = filter as FilterType

  const typeSavedOptionsLength = (savedOptions?.[type] || []).length
  // Only load the greater of 25 and the number of selected options to avoid performance issues
  const nbOfvisibleOptions = Math.max(FILTER_MAX_RESULT_VISIBLE, typeSavedOptionsLength)
  const visibleOptions = useMemo(() => slice(sortedOptions, 0, nbOfvisibleOptions), [sortedOptions, nbOfvisibleOptions])

  const [firstTimeOpen, setFirstTimeOpen] = useState(isOpen)
  const [initialOptions, setInitialOptions] = useState(visibleOptions)

  // Move the selected options at the top of the list only at first opening of the dropdown
  useEffect(() => {
    if (!firstTimeOpen) return
    const typeSavedOptions = savedOptions?.[type] || []
    const sortedBySelectedOptions = sortBy(sortedOptions, [option => !typeSavedOptions?.includes(option._id)])
    setInitialOptions(slice(sortedBySelectedOptions, 0, nbOfvisibleOptions))
    setFirstTimeOpen(false)
  }, [firstTimeOpen, nbOfvisibleOptions, savedOptions, sortedOptions, type])

  return initialOptions
}

export default useInitialOptions
